import { render, staticRenderFns } from "./AppNotificationBanner.vue?vue&type=template&id=dca02ab8&scoped=true&"
import script from "./AppNotificationBanner.vue?vue&type=script&lang=js&"
export * from "./AppNotificationBanner.vue?vue&type=script&lang=js&"
import style0 from "./AppNotificationBanner.vue?vue&type=style&index=0&id=dca02ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca02ab8",
  null
  
)

export default component.exports